import { Badge, Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import { SearchContext } from "./utils";

interface SearchContextSummaryProps {
  context: SearchContext;
}

/**
 * Renders the search context from a multi-sport agent answer as a compact
 * summary showing the sport, query used, result count, and relevant metadata
 * fields. Displayed below the message prose (similar to MetadataFiltersSummary
 * for the NBA path).
 */
const SearchContextSummary: React.FC<SearchContextSummaryProps> = ({
  context,
}) => {
  return (
    <div data-testid="search-context-summary">
      <SpaceBetween size="xxs">
        <SpaceBetween direction="horizontal" size="xs">
          <Box
            variant="strong"
            fontSize="body-s"
            color="text-body-secondary"
            padding={{ top: "xxs" }}
          >
            Search:
          </Box>
          {context.sport && <Badge color="blue">{context.sport}</Badge>}
          {context.query && <Badge color="grey">{context.query}</Badge>}
          <Badge color={context.results_found > 0 ? "green" : "red"}>
            {context.results_found} clip
            {context.results_found !== 1 ? "s" : ""} found
          </Badge>
        </SpaceBetween>
        {context.relevant_fields.length > 0 && (
          <SpaceBetween direction="horizontal" size="xs">
            <Box
              fontSize="body-s"
              color="text-body-secondary"
              padding={{ left: "xxs" }}
            >
              Relevant fields:
            </Box>
            {context.relevant_fields.map((field) => (
              <Badge key={field} color="blue">
                {field}
              </Badge>
            ))}
          </SpaceBetween>
        )}
      </SpaceBetween>
    </div>
  );
};

export default SearchContextSummary;
